import { Project } from '../shared/models/Project';
import { ProjectListParams, PaginatedResponse, CreateProjectRequest, UpdateProjectRequest, ReviewProjectRequest } from '../types/api';
import { get, post, put, patch } from './api';

/**
 * 项目服务
 */
export class ProjectService {
  /**
   * 获取项目列表（公开接口，用于H5）
   */
  static async getProjects(params?: ProjectListParams): Promise<PaginatedResponse<Project>> {
    return get<PaginatedResponse<Project>>('/public/projects', params);
  }

  /**
   * 获取项目详情（公开接口，用于H5）
   */
  static async getProjectById(id: string): Promise<Project> {
    return get<Project>(`/public/projects/${id}`);
  }

  /**
   * 创建项目
   */
  static async createProject(data: CreateProjectRequest): Promise<Project> {
    return post<Project>('/projects', data);
  }

  /**
   * 更新项目
   */
  static async updateProject(id: string, data: UpdateProjectRequest): Promise<Project> {
    return put<Project>(`/projects/${id}`, data);
  }

  /**
   * 部分更新项目
   */
  static async patchProject(id: string, data: Partial<UpdateProjectRequest>): Promise<Project> {
    return patch<Project>(`/projects/${id}`, data);
  }

  /**
   * 发布项目
   */
  static async publishProject(id: string): Promise<Project> {
    return patch<Project>(`/projects/${id}`, { status: 'PUBLISHED', publishTime: new Date().toISOString() });
  }

  /**
   * 下架项目
   */
  static async offlineProject(id: string): Promise<Project> {
    return patch<Project>(`/projects/${id}`, { status: 'OFFLINE' });
  }

  /**
   * 审核项目（仅公募机构）
   */
  static async reviewProject(id: string, reviewData: ReviewProjectRequest): Promise<Project> {
    const status = reviewData.result === 'APPROVED' ? 'PUBLISHED' : 'REJECTED';
    return patch<Project>(`/projects/${id}`, {
      status,
      reviewComment: reviewData.comment,
      reviewTime: new Date().toISOString(),
    });
  }
}

